import React from "react";
import iconLogo from "../../../assets/icon-logo.png";

interface Team {
  id: number;
  team_id: string;
  team_name: string;
  profile_status: string;
  team_status: string;
  [key: string]: any;
}

interface AwaitingAdminApprovalStatusProps {
  team: Team;
  onUpdate: () => void;
}

const AwaitingAdminApprovalStatus: React.FC<
  AwaitingAdminApprovalStatusProps
> = ({ team, onUpdate }) => {
  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="text-center py-8">
        {/* Icon/Image placeholder */}
        <div className="w-20 mx-auto flex items-center justify-center">
          <img src={iconLogo} className="w-full" alt="Logo" />
        </div>

        <p className="text-lg font-semibold text-gray-900 mb-2">
          Your application is under review
        </p>

        <div className="space-y-2">
          <p className="text-sm text-blue-600 mb-4">
            ⏳ Your team application has been submitted and is currently being
            reviewed by our admin team.
          </p>
          <div className="w-full bg-blue-100 text-blue-800 py-3 px-6 rounded-lg font-medium">
            <div className="flex items-center justify-center space-x-2">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
              <span>Waiting for Admin Approval</span>
            </div>
          </div>
          {/* <p className="text-xs text-gray-500 mt-2">
            Please check your email for results in 2 days.
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default AwaitingAdminApprovalStatus;
